import React from 'react';
import PropTypes from 'prop-types';

import Parser from 'html-react-parser';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

class BlogSingleImage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {input} = this.props
        return (
            <span className="image fit">
                <Img fluid={input.primary.img.localFile.childImageSharp.fluid} />
                {Parser(input.primary.imgcaption.html)}
            </span>
        )
    }
}
BlogSingleImage.propTypes = {
    input: PropTypes.object.isRequired,
};

export default BlogSingleImage;